import { z } from 'zod';
import type {
    IdempotencyCleanupResponse,
    IdempotencyConflictCode,
    IdempotencyConflictResponse,
} from '../idempotency.types';
import { NonEmptyStringSchema } from './common.schemas';

export const IdempotencyConflictCodeSchema: z.ZodType<IdempotencyConflictCode> = z.union([
    z.literal('IDEMPOTENCY_REQUEST_IN_PROGRESS'),
    z.literal('IDEMPOTENCY_REQUEST_ALREADY_COMPLETED'),
    z.literal('IDEMPOTENCY_KEY_REUSED_WITH_DIFFERENT_REQUEST'),
]);

export const IdempotencyConflictResponseSchema: z.ZodType<IdempotencyConflictResponse> = z.object(
    {
        code: IdempotencyConflictCodeSchema,
        message: NonEmptyStringSchema,
        conflict_resource_type: z.literal('IDEMPOTENCY_REQUEST'),
        conflict_uuid: z.uuid(),
        conflict_field: NonEmptyStringSchema.optional(),
        conflict_value: NonEmptyStringSchema.optional(),
    }
);

export const IdempotencyCleanupResponseSchema: z.ZodType<IdempotencyCleanupResponse> = z.object({
    deleted_count: z.number().int().nonnegative(),
});
